import React from 'react';
import Kbd from 'design-system/Kbd';

export const renderTrigger = (trigger: string) => {
  return trigger.split('+').map((singleKey, i) => <Kbd key={i}>{singleKey}</Kbd>);
};

export const MODIFIERS: Record<string, string> = {
  Control: 'ctrl',
  Meta: 'cmd',
  Alt: 'alt',
  Shift: 'shift',
};

export const EXIT_TRIGGER = '/';

export const INVALID_TRIGGERS = [',', 'CapsLock', '/'];

export const KEYMAP: Record<string, string> = {
  ArrowDown: 'down',
  ArrowUp: 'up',
  ArrowLeft: 'left',
  ArrowRight: 'right',
};
